;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="c15b1ca2-5d8a-4d37-a725-269c2c6b31a0",e._sentryDebugIdIdentifier="sentry-dbid-c15b1ca2-5d8a-4d37-a725-269c2c6b31a0")}catch(e){}}();
"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5130],{

/***/ 88156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var BrimbleLogo = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: "28",
        height: "32",
        viewBox: "0 0 28 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M17.9494 12.4612H11.5725C11.4634 12.4612 11.3588 12.4178 11.2817 12.3407C11.2046 12.2636 11.1613 12.159 11.1613 12.05C11.1613 11.9409 11.2046 11.8363 11.2817 11.7592C11.3588 11.6821 11.4634 11.6388 11.5725 11.6388H15.0809C16.6243 11.6388 18.1045 11.0256 19.1958 9.9343C20.2871 8.84295 20.9003 7.36277 20.9003 5.81938C20.9003 4.27598 20.2871 2.7958 19.1958 1.70446C18.1045 0.613112 16.6243 0 15.0809 0H8.53119V5.48712C7.28 6.0677 6.22077 6.99373 5.47826 8.15616C4.73575 9.31858 4.34089 10.669 4.34018 12.0483C4.33842 12.6912 4.42363 13.3313 4.59349 13.9514C2.79409 15.0749 1.40946 16.7537 0.649016 18.7341C-0.111431 20.7144 -0.20634 22.8885 0.378643 24.9276C0.963626 26.9667 2.19668 28.7598 3.89134 30.0358C5.58599 31.3118 7.65006 32.0013 9.77139 32H17.9494C20.5407 32 23.0258 30.9706 24.8581 29.1384C26.6903 27.3061 27.7197 24.821 27.7197 22.2298C27.7197 19.6385 26.6903 17.1534 24.8581 15.3212C23.0258 13.4889 20.5407 12.4595 17.9494 12.4595V12.4612ZM17.9494 29.7318H9.77139C7.97058 29.7329 6.22955 29.0857 4.8668 27.9085C3.50404 26.7313 2.61067 25.1028 2.3501 23.3209C2.08953 21.539 2.47918 19.7229 3.44778 18.2048C4.41638 16.6866 5.89917 15.568 7.6249 15.0534C7.06634 14.3184 6.72418 13.442 6.637 12.5229C6.54982 11.6039 6.72107 10.6787 7.13146 9.8518C7.54185 9.02486 8.17506 8.32899 8.95972 7.84262C9.74438 7.35625 10.6493 7.09872 11.5725 7.09905H15.0809C15.4181 7.09905 15.7415 6.96509 15.9799 6.72665C16.2184 6.48821 16.3523 6.16481 16.3523 5.8276C16.3523 5.49039 16.2184 5.167 15.9799 4.92855C15.7415 4.69011 15.4181 4.55616 15.0809 4.55616H10.8043V2.27479H15.0809C15.5529 2.26462 16.0222 2.34881 16.4612 2.52241C16.9003 2.69602 17.3002 2.95555 17.6377 3.28578C17.9751 3.61601 18.2432 4.01029 18.4262 4.44549C18.6092 4.8807 18.7035 5.34807 18.7035 5.8202C18.7035 6.29233 18.6092 6.7597 18.4262 7.19491C18.2432 7.63011 17.9751 8.0244 17.6377 8.35462C17.3002 8.68485 16.9003 8.94438 16.4612 9.11799C16.0222 9.29159 15.5529 9.37578 15.0809 9.36561H11.5725C11.2145 9.35675 10.8583 9.41961 10.525 9.55048C10.1917 9.68136 9.88788 9.87761 9.63154 10.1277C9.37521 10.3777 9.1715 10.6766 9.03242 11.0066C8.89333 11.3365 8.82168 11.691 8.82168 12.0491C8.82168 12.4072 8.89333 12.7617 9.03242 13.0917C9.1715 13.4217 9.37521 13.7205 9.63154 13.9706C9.88788 14.2207 10.1917 14.4169 10.525 14.5478C10.8583 14.6787 11.2145 14.7415 11.5725 14.7327H17.9494C19.9184 14.7618 21.7967 15.5644 23.1788 16.9671C24.5608 18.3697 25.3355 20.2598 25.3355 22.2289C25.3355 24.1981 24.5608 26.0881 23.1788 27.4908C21.7967 28.8934 19.9184 29.696 17.9494 29.7252V29.7318ZM17.9494 17.014H9.77139C9.07789 17.0017 8.3889 17.1277 7.74462 17.3846C7.10033 17.6414 6.51368 18.0241 6.01889 18.5102C5.52411 18.9962 5.13111 19.576 4.86284 20.2156C4.59457 20.8553 4.4564 21.5419 4.4564 22.2355C4.4564 22.9291 4.59457 23.6158 4.86284 24.2554C5.13111 24.895 5.52411 25.4748 6.01889 25.9609C6.51368 26.4469 7.10033 26.8296 7.74462 27.0865C8.3889 27.3433 9.07789 27.4693 9.77139 27.457H17.9494C18.6429 27.4693 19.3319 27.3433 19.9762 27.0865C20.6205 26.8296 21.2072 26.4469 21.7019 25.9609C22.1967 25.4748 22.5897 24.895 22.858 24.2554C23.1263 23.6158 23.2644 22.9291 23.2644 22.2355C23.2644 21.5419 23.1263 20.8553 22.858 20.2156C22.5897 19.576 22.1967 18.9962 21.7019 18.5102C21.2072 18.0241 20.6205 17.6414 19.9762 17.3846C19.3319 17.1277 18.6429 17.0017 17.9494 17.014ZM17.9494 25.1839H9.77139C8.98966 25.1839 8.23994 24.8733 7.68718 24.3205C7.13441 23.7678 6.82387 23.0181 6.82387 22.2363C6.82387 21.4546 7.13441 20.7049 7.68718 20.1521C8.23994 19.5994 8.98966 19.2888 9.77139 19.2888H17.9494C18.7312 19.2888 19.4809 19.5994 20.0337 20.1521C20.5864 20.7049 20.897 21.4546 20.897 22.2363C20.897 23.0181 20.5864 23.7678 20.0337 24.3205C19.4809 24.8733 18.7312 25.1839 17.9494 25.1839Z",
            fill: "currentColor"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BrimbleLogo);


/***/ }),

/***/ 37031:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);





var CheckBoxComponent = function(_param) {
    var title = _param.title, className = _param.className, checked = _param.checked, children = _param.children, inputClass = _param.inputClass, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "title",
        "className",
        "checked",
        "children",
        "inputClass"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "form-control rounded-none ".concat(className),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
            className: "flex flex-row items-center justify-start space-x-3 truncate cursor-pointer label whitespace-nowrap",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    checked: checked,
                    type: "checkbox",
                    className: "checkbox checkbox-primary " + inputClass
                })),
                children ? children : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "lg:text-base text-sm capitalize",
                    children: title
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CheckBoxComponent);


/***/ }),

/***/ 94139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ Micro_Skeleton; }
});

// UNUSED EXPORTS: Skeleton, SkeletonBackground

// EXTERNAL MODULE: ./components/Micro/Skeleton/Skeleton.tsx
var Skeleton = __webpack_require__(50124);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/Micro/Skeleton/SkeletonBackground.tsx



var SkeletonBackground = function(param) {
    var className = param.className, _animate = param.animate, animate = _animate === void 0 ? true : _animate, children = param.children, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, height = param.height, width = param.width, _rounded = param.rounded, rounded = _rounded === void 0 ? true : _rounded;
    // Base styles for all variants
    var baseStyles = "overflow-hidden bg-gray-200 dark:bg-theme-color-light";
    // Variant-specific styles
    var variantStyles = {
        default: "",
        card: "p-4 shadow-sm",
        table: "p-2",
        text: "h-4"
    };
    // Custom dimensions if provided
    var dimensionStyles = {
        height: height ? "h-".concat(height) : "",
        width: width ? "w-".concat(width) : ""
    };
    // Border radius styles
    var roundedStyles = rounded ? "rounded" : "";
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(baseStyles, variantStyles[variant], dimensionStyles.height, dimensionStyles.width, roundedStyles, animate && "animate-pulse", className),
        children: children
    });
};
/* harmony default export */ var Skeleton_SkeletonBackground = ((/* unused pure expression or super */ null && (SkeletonBackground)));

;// CONCATENATED MODULE: ./components/Micro/Skeleton/index.tsx



/* harmony default export */ var Micro_Skeleton = (Skeleton/* default */.Z);


/***/ }),

/***/ 23033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_icons_fi__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90512);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55406);
/* harmony import */ var _Skeleton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94139);











var TextField = function(_param) {
    var label = _param.label, className = _param.className, containerClass = _param.containerClass, helperText = _param.helperText, error = _param.error, _nobg = _param.nobg, nobg = _nobg === void 0 ? false : _nobg, value = _param.value, rightIcon = _param.rightIcon, title = _param.title, _validateInput = _param.validateInput, validateInput = _validateInput === void 0 ? false : _validateInput, _scrollable = _param.scrollable, scrollable = _scrollable === void 0 ? false : _scrollable, onChange = _param.onChange, _isApiKey = _param.isApiKey, isApiKey = _isApiKey === void 0 ? false : _isApiKey, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "label",
        "className",
        "containerClass",
        "helperText",
        "error",
        "nobg",
        "value",
        "rightIcon",
        "title",
        "validateInput",
        "scrollable",
        "onChange",
        "isApiKey"
    ]);
    var ref, ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isDecrypting = ref3[0], setIsDecrypting = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), showPassword = ref4[0], setShowPassword = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), decryptedValue = ref5[0], setDecryptedValue = ref5[1];
    var sanitizeRegex = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return /[^a-zA-Z-]/g;
    }, []);
    var handleToggle = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var decrypted;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!isApiKey) {
                            _ctx.next = 20;
                            break;
                        }
                        setShowPassword(!showPassword);
                        if (!(!showPassword && !decryptedValue && value)) {
                            _ctx.next = 17;
                            break;
                        }
                        setIsDecrypting(true);
                        _ctx.prev = 4;
                        _ctx.next = 7;
                        return decipherApiKey(value);
                    case 7:
                        decrypted = _ctx.sent;
                        setDecryptedValue(decrypted);
                        _ctx.next = 14;
                        break;
                    case 11:
                        _ctx.prev = 11;
                        _ctx.t0 = _ctx["catch"](4);
                        console.error("Failed to decrypt API key:", _ctx.t0);
                    case 14:
                        _ctx.prev = 14;
                        setIsDecrypting(false);
                        return _ctx.finish(14);
                    case 17:
                        if (ref2.current) {
                            ref2.current.type = !showPassword ? "text" : "password";
                        }
                        _ctx.next = 21;
                        break;
                    case 20:
                        {
                            setShowPassword(!showPassword);
                            if (ref2.current) {
                                ref2.current.type = showPassword ? "password" : "text";
                            }
                        }
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    4,
                    11,
                    14,
                    17
                ]
            ]);
        }));
        return function handleToggle() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChange = function(e) {
        if (validateInput) {
            var sanitizedValue = e.target.value.replace(sanitizeRegex, "");
            e.target.value = sanitizedValue;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
        if (isApiKey) {
            setDecryptedValue(null);
        }
    };
    var isCommand = ((ref = props.name) === null || ref === void 0 ? void 0 : ref.includes("command")) || ((ref1 = props.name) === null || ref1 === void 0 ? void 0 : ref1.includes("script")) || false;
    var formatShellScript = function(cmd) {
        if (!cmd) return "";
        var shebang = "";
        if (cmd.startsWith("#!")) {
            var shebangEnd = cmd.indexOf("\n");
            if (shebangEnd > -1) {
                shebang = cmd.substring(0, shebangEnd + 1);
                cmd = cmd.substring(shebangEnd + 1);
            }
        }
        var formatted = cmd.replace(/\s*&&\s*/g, " &&\n").replace(/\s*;\s*/g, ";\n").replace(/\s*\|\|\s*/g, " ||\n").replace(/\s*\|\s*/g, " |\n").split("\n").map(function(line) {
            return line.trim();
        }).filter(function(line) {
            return line;
        }).join("\n");
        return shebang + formatted;
    };
    var decipherApiKey = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(apiKey) {
            var decrypted;
            return _app_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,_helpers__WEBPACK_IMPORTED_MODULE_3__/* .decryptEnv */ .Fc)([
                            {
                                name: "API_KEY",
                                value: apiKey
                            }
                        ]);
                    case 2:
                        decrypted = _ctx.sent;
                        return _ctx.abrupt("return", decrypted[0].value);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function decipherApiKey(apiKey) {
            return _ref.apply(this, arguments);
        };
    }();
    // Determine the display value
    var displayValue = isApiKey && showPassword && decryptedValue ? decryptedValue : value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("form-control rounded-none w-full", containerClass),
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("label text-[14px]", {
                    "text-error is-inValid": error
                }),
                htmlFor: props.name,
                children: label
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "relative w-full dark:border-theme-color-light",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("w-full", {
                            "overflow-x-auto": scrollable
                        }),
                        children: isApiKey && isDecrypting ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: "input rounded-none input-bordered input-lg w-full h-[54px] flex items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                                    className: "w-full h-4"
                                }),
                                " "
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            ref: ref2,
                            title: title,
                            required: true,
                            autoCorrect: "off",
                            autoComplete: "off",
                            autoCapitalize: "off"
                        }, props), {
                            value: displayValue,
                            onChange: handleChange,
                            className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("input rounded-none input-bordered input-lg w-full h-[54px]", {
                                "bg-light2": !nobg,
                                "!border-error text-error placeholder-error is-inValid": error,
                                "border-primary": !error,
                                "whitespace-nowrap min-w-full": scrollable
                            }, "focus:outline-none dark:bg-theme-color disabled:dark:bg-theme-color/50 disabled:bg-light/50", className),
                            style: scrollable ? {
                                overflow: "auto",
                                textOverflow: "initial"
                            } : undefined
                        }))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: "absolute top-0 right-0 flex items-center justify-center h-full px-3 z-10",
                        children: rightIcon || (props.type === "password" || isApiKey) && (isDecrypting ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "w-5 h-5 rounded-full border-2 border-primary border-t-transparent animate-spin"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                            onClick: handleToggle,
                            className: "cursor-pointer text-primary",
                            type: "button",
                            children: showPassword ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_10__/* .FiEyeOff */ .rzC, {
                                size: 20
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_fi__WEBPACK_IMPORTED_MODULE_10__/* .FiEye */ .rDJ, {
                                size: 20
                            })
                        }))
                    })
                ]
            }),
            isCommand && value && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "mt-2 border rounded dark:border-theme-color-light overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "bg-gray-100 dark:bg-theme-color-dark p-2 text-xs font-semibold border-b dark:border-theme-color-light",
                        children: "Command Preview"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("pre", {
                        className: "p-3 text-sm whitespace-pre overflow-auto max-h-56 bg-gray-50 dark:bg-gray-900 dark:text-gray-100",
                        children: formatShellScript(String(value))
                    })
                ]
            }),
            Boolean(helperText) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (0,clsx__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("my-2 text-[14px]", {
                    "text-error is-inValid": error,
                    "border-primary !text-black dark:!text-white": !error
                }),
                children: helperText
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextField);


/***/ }),

/***/ 57923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _TextField__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _TextField__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23033);



/***/ }),

/***/ 49352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layouts_AuthLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/LeftAuthPanel/LeftAuthPanel.tsx


var LeftAuthPanel = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full md:w-1/2 min-h-full bg-[url('https://res.cloudinary.com/dgqfojhx4/image/upload/v1741691580/dashboard-assets/login-home_r721oa.svg')] bg-contain bg-no-repeat bg-right px-5 md:px-20 pt-14 space-y-10 flex flex-col md:justify-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-aos": "fade-up",
                "data-aos-duration": "1000",
                className: "text-white capitalize flex items-start font-semibold space-x-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M21.0001 12.0699V12.9999C20.9975 17.4286 18.0824 21.3281 13.8354 22.5838C9.58847 23.8395 5.02145 22.1522 2.61101 18.437C0.200573 14.7217 0.52092 9.86353 3.39833 6.49696C6.27574 3.13039 11.0248 2.05741 15.0701 3.85989",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M22 4L11 15L8 12",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-2xl",
                                children: "Instant product deployment"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white font-normal w-4/5",
                                children: "In minutes, without ops, build websites and campaigns"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-aos": "fade-up",
                "data-aos-duration": "1500",
                className: "text-white capitalize flex items-start font-semibold space-x-2 opacity-90",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M21.0001 12.0699V12.9999C20.9975 17.4286 18.0824 21.3281 13.8354 22.5838C9.58847 23.8395 5.02145 22.1522 2.61101 18.437C0.200573 14.7217 0.52092 9.86353 3.39833 6.49696C6.27574 3.13039 11.0248 2.05741 15.0701 3.85989",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M22 4L11 15L8 12",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-2xl",
                                children: "Quick Product Rollout"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white font-normal w-4/5",
                                children: "Worry no more about server configurations; just start developing."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-aos": "fade-up",
                "data-aos-duration": "2000",
                className: "text-white capitalize flex items-start font-semibold space-x-2 opacity-70",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M21.0001 12.0699V12.9999C20.9975 17.4286 18.0824 21.3281 13.8354 22.5838C9.58847 23.8395 5.02145 22.1522 2.61101 18.437C0.200573 14.7217 0.52092 9.86353 3.39833 6.49696C6.27574 3.13039 11.0248 2.05741 15.0701 3.85989",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M22 4L11 15L8 12",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-2xl",
                                children: "Team Collaboration"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white font-normal w-4/5",
                                children: "Together is better. With invite links, onboard your team."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-aos": "fade-up",
                "data-aos-duration": "2500",
                className: "text-white capitalize flex items-start font-semibold space-x-2 opacity-50",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M21.0001 12.0699V12.9999C20.9975 17.4286 18.0824 21.3281 13.8354 22.5838C9.58847 23.8395 5.02145 22.1522 2.61101 18.437C0.200573 14.7217 0.52092 9.86353 3.39833 6.49696C6.27574 3.13039 11.0248 2.05741 15.0701 3.85989",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M22 4L11 15L8 12",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-2xl",
                                children: "Shortcuts at your finger tips"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white font-normal w-4/5",
                                children: "Providing quick and easy access to deployment functions"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                "data-aos": "fade-up",
                "data-aos-duration": "3000",
                className: "text-white capitalize flex items-start font-semibold space-x-2 opacity-30",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M21.0001 12.0699V12.9999C20.9975 17.4286 18.0824 21.3281 13.8354 22.5838C9.58847 23.8395 5.02145 22.1522 2.61101 18.437C0.200573 14.7217 0.52092 9.86353 3.39833 6.49696C6.27574 3.13039 11.0248 2.05741 15.0701 3.85989",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M22 4L11 15L8 12",
                                    stroke: "white",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-2xl",
                                children: "Automated Builds"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-white font-normal w-4/5",
                                children: "Whenever you push to Git, Brimble detects and triggers auto-deploy."
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var LeftAuthPanel_LeftAuthPanel = (LeftAuthPanel);

;// CONCATENATED MODULE: ./components/LeftAuthPanel/index.ts


;// CONCATENATED MODULE: ./layouts/AuthLayout.tsx



var AuthLayout = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: "flex flex-col-reverse items-start md:overflow-hidden min-w-screen md:flex-row bg-primary",
        style: {
            height: "calc(100vh * 1.24)"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeftAuthPanel_LeftAuthPanel, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col justify-center w-full h-full overflow-hidden bg-white md:w-1/2 dark:bg-theme-color md:min-h-screen px-5 pt-10 md:p-20",
                children: props === null || props === void 0 ? void 0 : props.children
            })
        ]
    });
};
/* harmony default export */ var layouts_AuthLayout = (AuthLayout);


/***/ }),

/***/ 5130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AuthLabel": function() { return /* binding */ AuthLabel; },
  "VerifyLabel": function() { return /* binding */ VerifyLabel; },
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ email; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./Icons/BrimbleLogo.tsx
var BrimbleLogo = __webpack_require__(88156);
// EXTERNAL MODULE: ./components/Micro/TextField/index.ts
var TextField = __webpack_require__(57923);
// EXTERNAL MODULE: ./components/Micro/Button/index.ts
var Button = __webpack_require__(56425);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82175);
// EXTERNAL MODULE: ./node_modules/sonner/dist/index.mjs
var dist = __webpack_require__(64712);
// EXTERNAL MODULE: ./backend/auth/index.ts
var auth = __webpack_require__(55263);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./context/index.tsx + 12 modules
var context = __webpack_require__(29017);
// EXTERNAL MODULE: ./context/reducer.ts
var reducer = __webpack_require__(69672);
// EXTERNAL MODULE: ./utils/validation.ts
var validation = __webpack_require__(18702);
// EXTERNAL MODULE: ./backend/index.ts
var backend = __webpack_require__(12901);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/Micro/CheckBoxComponent/CheckBoxComponent.tsx
var CheckBoxComponent = __webpack_require__(37031);
;// CONCATENATED MODULE: ./components/Micro/CheckBoxComponent/index.ts


// EXTERNAL MODULE: ./components/Micro/Seo/index.tsx
var Seo = __webpack_require__(72418);
// EXTERNAL MODULE: ./layouts/AuthLayout.tsx + 2 modules
var AuthLayout = __webpack_require__(49352);
;// CONCATENATED MODULE: ./pages/register/email.tsx




// import LeftAuthPanel from "../../components/LeftAuthPanel";















var Register = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isChecked = ref[0], setIsChecked = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), loading = ref1[0], setLoading = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState({
        email: "",
        username: ""
    }), 2), error = ref2[0], setError = ref2[1];
    var dispatch = (0,context/* useStoreContext */.QT)().dispatch;
    var handleUserLookup = function(data) {
        (0,auth/* userLookup */.YC)(data).then(function() {
            var tmp = (0,_object_spread/* default */.Z)({}, error);
            tmp[Object.keys(data)[0]] = "";
            setError(tmp);
        }).catch(function(res) {
            if ((res === null || res === void 0 ? void 0 : res.status) === 400) {
                var tmp = (0,_object_spread/* default */.Z)({}, error);
                tmp[Object.keys(data)[0]] = res.data.message;
                setError(tmp);
            }
        });
    };
    var handleRegister = function(registrationPayload, resetForm) {
        if (!Object.values(error).join("").trim()) {
            setLoading(true);
            (0,auth/* register */.z2)(registrationPayload).then(function(param) {
                var data = param.data;
                dispatch({
                    type: reducer/* Actions.AUTHENTICATE */.e.AUTHENTICATE,
                    payload: data.data
                });
                resetForm();
                dist/* toast.success */.A.success("Account created successfully!", {
                    duration: 10000
                });
                router.push("/login/verification?email=".concat(registrationPayload.email, "&from=register"));
            }).catch(backend/* handleRequestError */.Yt).finally(function() {
                return setLoading(false);
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* default */.Z, {
                title: "Registration",
                description: "Create an account to start using Brimble"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthLayout/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
                    initialValues: {
                        email: "",
                        username: "",
                        first_name: "",
                        last_name: "",
                        company: ""
                    },
                    validationSchema: validation/* default.register */.Z.register,
                    onSubmit: function(data, param) {
                        var resetForm = param.resetForm;
                        return handleRegister(data, resetForm);
                    },
                    children: function(param) {
                        var errors = param.errors, values = param.values, touched = param.touched, handleSubmit = param.handleSubmit, handleChange = param.handleChange, handleBlur = param.handleBlur;
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center justify-between w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "space-y-3 w-4/5",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                    className: "text-4xl font-extrabold md:text-[40px] text-primary-dark dark:text-white",
                                                    children: [
                                                        "Ship your",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "text-blue-600 italic",
                                                            children: "Applications"
                                                        }),
                                                        " ",
                                                        "fast and easy"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    className: "text-gray-600 dark:text-gray-400 text-lg w-4/5 md:w-2/3 lg:w-2/3 xl:1/2",
                                                    children: "Create an account to start deploying on brimble."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "https://brimble.io",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex items-center justify-center w-16 h-16 rounded-full bg-light",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BrimbleLogo/* default */.Z, {})
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full py-5 space-y-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "grid w-full grid-cols-2 gap-x-3 gap-y-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    value: values["first_name"],
                                                    error: Boolean(errors["first_name"]),
                                                    helperText: touched["first_name"] && errors["first_name"],
                                                    touched: touched["first_name"],
                                                    onChange: handleChange,
                                                    onBlur: handleBlur,
                                                    type: "text",
                                                    name: "first_name",
                                                    placeholder: "Armstrong",
                                                    label: "First Name *",
                                                    className: "!input-md border-none dark:bg-theme-color-light"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    value: values["last_name"],
                                                    error: Boolean(errors["last_name"]),
                                                    helperText: touched["last_name"] && errors["last_name"],
                                                    touched: touched["last_name"],
                                                    onChange: handleChange,
                                                    onBlur: handleBlur,
                                                    type: "text",
                                                    name: "last_name",
                                                    placeholder: "Niel",
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-sm text-gray-700 dark:text-gray-300",
                                                        children: [
                                                            "Last Name",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-gray-500 italic",
                                                                children: "(Optional)"
                                                            })
                                                        ]
                                                    }),
                                                    className: "!input-md border-none dark:bg-theme-color-light"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    value: values["email"],
                                                    error: Boolean(errors["email"]) || !!error.email,
                                                    helperText: touched["email"] && errors["email"] || error.email,
                                                    touched: touched["email"],
                                                    onChange: handleChange,
                                                    onBlur: function(event) {
                                                        handleBlur(event);
                                                        if (values.email) {
                                                            handleUserLookup({
                                                                email: values.email
                                                            });
                                                        }
                                                    },
                                                    type: "email",
                                                    name: "email",
                                                    placeholder: "armstrong@gmail.com",
                                                    label: "Email *",
                                                    containerClass: "col-span-2",
                                                    className: "!input-md border-none dark:bg-theme-color-light"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    value: values["username"],
                                                    error: Boolean(errors["username"]) || !!error.username,
                                                    helperText: touched["username"] && errors["username"] || error.username,
                                                    touched: touched["username"],
                                                    onChange: handleChange,
                                                    onBlur: function(event) {
                                                        handleBlur(event);
                                                        if (values.username) {
                                                            handleUserLookup({
                                                                username: values.username
                                                            });
                                                        }
                                                    },
                                                    type: "text",
                                                    name: "username",
                                                    placeholder: "username",
                                                    label: "Username *",
                                                    className: "!input-md border-none dark:bg-theme-color-light"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                    value: values["company"],
                                                    error: Boolean(errors["company"]),
                                                    helperText: touched["company"] && errors["company"],
                                                    touched: touched["company"],
                                                    onChange: handleChange,
                                                    onBlur: handleBlur,
                                                    type: "text",
                                                    name: "company",
                                                    placeholder: "company",
                                                    label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "text-sm text-gray-700 dark:text-gray-300",
                                                        children: [
                                                            "Company",
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-gray-500 italic",
                                                                children: "(Optional)"
                                                            })
                                                        ]
                                                    }),
                                                    className: "!input-md border-none dark:bg-theme-color-light"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex items-center space-x-2 !my-5 text-[12px] font-mono",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBoxComponent/* default */.Z, {
                                                    checked: isChecked,
                                                    onChange: function(e) {
                                                        return setIsChecked(e.currentTarget.checked);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        "I agree to the terms and conditions of",
                                                        " ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "#",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "text-primary cursor-pointer",
                                                                children: "Brimble"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            loading: loading,
                                            type: "submit",
                                            onClick: function() {
                                                return handleSubmit();
                                            },
                                            className: "text-md btn-block btn-md",
                                            disabled: isChecked === false,
                                            children: "continue"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                return router.push("/register");
                                            },
                                            className: "mt-5 text-[14px] font-medium capitalize btn-link text-primary dark:text-gray-400 btn btn-primary btn-block btn-lg no-underline",
                                            children: "Use other Registration options"
                                        })
                                    ]
                                })
                            ]
                        });
                    }
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var email = (Register);
var AuthLabel = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "flex items-center space-x-2 text-sm font-semibold text-black label-text dark:text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15 15.75V14.25C15 12.5931 13.6569 11.25 12 11.25H6C4.34315 11.25 3 12.5931 3 14.25V15.75",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9 8.25C10.6569 8.25 12 6.90685 12 5.25C12 3.59315 10.6569 2.25 9 2.25C7.34315 2.25 6 3.59315 6 5.25C6 6.90685 7.34315 8.25 9 8.25Z",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Email Address"
            })
        ]
    });
};
var VerifyLabel = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "flex items-center space-x-2 text-sm font-semibold text-black label-text dark:text-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                width: "18",
                height: "18",
                viewBox: "0 0 18 18",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15 15.75V14.25C15 12.5931 13.6569 11.25 12 11.25H6C4.34315 11.25 3 12.5931 3 14.25V15.75",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9 8.25C10.6569 8.25 12 6.90685 12 5.25C12 3.59315 10.6569 2.25 9 2.25C7.34315 2.25 6 3.59315 6 5.25C6 6.90685 7.34315 8.25 9 8.25Z",
                        stroke: "currentColor",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "OTP Code"
            })
        ]
    });
};


/***/ }),

/***/ 18702:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _enum_project_enum__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72318);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74231);


// create a yup custom url validator
var urlRegex = new RegExp("^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$");
var username = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required("Please provide a username.").min(3).max(20).matches(/^[a-zA-Z0-9_]+$/, "Oops! Your username can only include letters, numbers, and underscores. Please adjust it accordingly.");
var email = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().email("Invalid email").required("Oops! Looks like you missed entering your email. It's a required field!");
var userSetting = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
    names: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required("It looks like you missed entering your name. Can you fill it in?"),
    email: email,
    username: username
});
var login = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
    email: email
});
var register = login.shape({
    first_name: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required("Please provide your first name."),
    last_name: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().optional(),
    username: username,
    company: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().optional()
});
var projectConfig = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
    git: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required().oneOf(Object.values(_enum_project_enum__WEBPACK_IMPORTED_MODULE_0__/* .GitType */ .kf)),
    framework: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
    healthCheckPath: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().optional().test("starts-with-slash", "Path must start with a forward slash", function(value) {
        if (!value) return true;
        return value.startsWith("/");
    }),
    repo: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
        name: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
        branch: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().when("git", {
            is: _enum_project_enum__WEBPACK_IMPORTED_MODULE_0__/* .GitType.Docker */ .kf.Docker,
            then: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().optional(),
            otherwise: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required("Branch is required")
        })
    }),
    authEnabled: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .boolean */ .O7)().default(false),
    rootDirectory: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    buildCommand: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    outputDirectory: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    branch: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().when("git", {
        is: _enum_project_enum__WEBPACK_IMPORTED_MODULE_0__/* .GitType.Docker */ .kf.Docker,
        then: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().optional(),
        otherwise: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required("Branch is required")
    }),
    installationId: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)(),
    teamId: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    environments: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)().of((0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
        name: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
        value: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
        id: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)()
    })),
    configurations: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
        cpu: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)().required().min(0.2),
        memory: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)().required().min(0.5),
        storage: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)().required().min(1),
        region: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
            _id: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
            name: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
            country: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
            continent: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
            enabled: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .boolean */ .O7)().required()
        }).required("Region is required")
    }).required("Configuration is required")
});
var dockerImageConfig = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
    image: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required("Docker image URL is required").matches(/^([a-z0-9]+(?:[._-][a-z0-9]+)*\/)*[a-z0-9]+(?:[._-][a-z0-9]+)*:[a-z0-9]+(?:[._-][a-z0-9]+)*$|^[a-z0-9]+(?:[._-][a-z0-9]+)*$/, "Invalid Docker image format. Please use one of the example formats shown."),
    registry: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
        id: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
        name: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required()
    }),
    username: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().optional(),
    token: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().when("username", {
        is: function(username) {
            return username && username.length > 0;
        },
        then: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required("Access token is required when username is provided"),
        otherwise: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().optional()
    })
});
var domain = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
    name: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required("Just a friendly reminder - we need the domain name to proceed.").test("is-url", "is invalid, Please enter a valid domain name", function(value) {
        if (!value) return false;
        return urlRegex.test(value);
    })
});
var newTeam = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
    team_name: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().min(3).max(16).required("Team is required").label("Team Name"),
    description: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    image: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)(),
    specifications: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)({
        members: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)().required("Number of members is required"),
        slack_support: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .boolean */ .O7)(),
        concurrent_builds: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)()
    }),
    members: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)().of((0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)()),
    card_id: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)()
});
var inviteMember = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
    members: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)().of((0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)()).min(1).required().label("Member")
});
var databaseConfig = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
    engine: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
    name: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
    region: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
    memory: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)().required(),
    storage: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)().required(),
    cpu: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)().required()
});
var updateDatabaseConfig = (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
    name: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
    memory: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)().required(),
    storage: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)().required(),
    cpu: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .number */ .Rx)().required(),
    ips: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .array */ .IX)().of((0,yup__WEBPACK_IMPORTED_MODULE_1__/* .object */ .Ry)().shape({
        id: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required(),
        ip: (0,yup__WEBPACK_IMPORTED_MODULE_1__/* .string */ .Z_)().required().matches(/^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\/([0-9]|[1-2][0-9]|3[0-2])$/, "IP address must be in CIDR format with prefix (e.g., 100.105.22.30/32)").test("cidr-required", "CIDR prefix is required (e.g., 100.105.22.30/32)", function(value) {
            return value ? value.includes("/") : false;
        })
    }))
});
var validation = {
    userSetting: userSetting,
    login: login,
    register: register,
    projectConfig: projectConfig,
    domain: domain,
    newTeam: newTeam,
    inviteMember: inviteMember,
    databaseConfig: databaseConfig,
    updateDatabaseConfig: updateDatabaseConfig,
    dockerImageConfig: dockerImageConfig
};
/* harmony default export */ __webpack_exports__["Z"] = (validation);


/***/ })

}]);